var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, persistent: "" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.enviar }
                },
                [_vm._v(" Enviar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Enviar notificação" } }),
      _c(
        "div",
        [
          _c(
            "v-form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("v-text-field", {
                attrs: { label: "Titulo*", rules: [_vm.rules.required] },
                model: {
                  value: _vm.titulo,
                  callback: function($$v) {
                    _vm.titulo = $$v
                  },
                  expression: "titulo"
                }
              }),
              _c("v-textarea", {
                attrs: { label: "Corpo*", rules: [_vm.rules.required] },
                model: {
                  value: _vm.corpo,
                  callback: function($$v) {
                    _vm.corpo = $$v
                  },
                  expression: "corpo"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }